import { useStandardProduct } from "app/hooks/shared/standard-product/useStandardProduct";
import React, { useCallback, useMemo } from "react";
import {
  CategoryStandardProduct,
  StandardProductCategory,
} from "shared/api/middleware-api-client";
import { StandardProductColor } from "./StandardProductColor";

interface ListProps {
  selectedCategory: StandardProductCategory | undefined;
}
export const StandardProductsColorProductList = ({
  selectedCategory,
}: ListProps) => {
  const { store, actions } = useStandardProduct();

  const selectedProduct = useMemo(
    () => store.selectedStandardProduct,
    [store.selectedStandardProduct],
  );
  const selectProduct = useCallback(
    (product: CategoryStandardProduct) =>
      actions.selectStandardProduct({
        ...product,
        amount: 1,
      }),
    [actions],
  );

  return (
    <div className="gg-my-4 gg-w-full gg-max-w-fit">
      <ul className="gg-grid gg-grid-cols-7 gg-gap-x-2.5 gg-gap-y-2.5">
        {selectedCategory?.product.map((categoryProduct, index) => {
          const isOptionActive =
            selectedProduct?.id === categoryProduct.standardProduct.id;

          return (
            <StandardProductColor
              key={categoryProduct.id}
              index={index}
              categoryProduct={categoryProduct}
              isOptionActive={isOptionActive}
              selectProduct={selectProduct}
            />
          );
        })}
      </ul>
    </div>
  );
};
